import AformItem from '@/components/AformItem';
import regexp from '../rules';
import './index.css';

export default {
  name: 'AfSearch',
  props: {
    id: { type: String, default: () => (`a-f-search-${Math.random().toString().substring(2)}`) },
    value: { type: Object, default: () => ({}) },
    must: { type: Boolean, default: () => false },
    inline: { type: Boolean, default: () => false },
    cols: { type: Number | String, default: () => 6 },
    gutter: { type: Number | String, default: () => 16 },
    rules: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({}) },
    global: { type: Boolean, default: () => true },
    prompt: { type: Boolean, default: () => false },
    expand: { type: Boolean, default: () => false },
    disabled: { type: Boolean, default: () => false },
  },
  data() {
    return {
      form: this.value,
      data: {},
      option: {},
      height: 'auto',
      opened: this.expand,
      timeout: null,
    }
  },
  watch: {
    expand(status = false) {
      this.opened = status;
    },
  },
  created() {
    this.relate(this.config);
  },
  mounted() {
    this.resize();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    input() {
      Object.keys(this.form).forEach(a => {
        if (typeof this.form[a] != 'object') {
          this.form[a] && (this.form[a] != '' && (this.form[a].trim && (this.form[a] = this.form[a].trim())));
        }
      });
      this.$emit('input', this.form);
    },
    change() {
      this.$emit('change', this.filter(), this.form, this.option);
    },
    toggle() {
      this.opened = !this.opened;
      this.$nextTick(() => {
        const height = this.opened ? this.height : 0;
        this.$nextTick(() => this.$emit('toggle', { opened: this.opened, height }));
      });
    },
    resize() {
      if (this.inline == false) {
        const config = {};
        Object.keys(this.config).forEach(a => this.config[a] && (config[a] = this.config[a]));
        this.$nextTick(() => {
          if (Object.keys(config).length > 0) {
            const rows = (Math.ceil(Object.keys(config).length / this.cols) - 1);
            this.$nextTick(() => {
              const main = document.getElementById(`${this.id}-main-rows`);
              this.$nextTick(() => main && (this.height = (main.clientHeight * rows)));
            });
          }
        });
      }
    },
    relate(config = {}) {
      const data = {};
      Object.keys(config).forEach(a => {
        const { ...r } = config[a];
        const child = r.children || r.child || r.node || null;
        if (child && Object.keys(child).length > 0) {
          this.relate(child);
        } else {
          const type = (r.type && (r.type != '')) ? r.type.toLowerCase().trim() : '';
          if ((r.multiple) || (type == 'cascader' || type == 'checkboxgroup')) {
            data[a] = [];
          }
          r.default && (data[a] = r.default);
        }
      });
      this.form = { ...data, ...this.value };
      if (this.global) this.$store.commit('setFormParams', this.form);
    },
    create(a, b) {
      if (!this.config[a]) return;
      const { rule = [], ...r } = this.config[a];
      const type = (r.type && (r.type != '')) ? r.type.toLowerCase().trim() : '';
      const label = r.text || r.label || r.title || r.name || '';
      const width = r.width ? r.width : (`${100 / this.cols}%`);
      const valid = r.type && regexp[r.type] ? [regexp[r.type]] : [];
      const check = (r.must == false || r.required == false) ? null : (this.must || r.must || r.required);
      const range = { min: (r.minlength || r.minLength || r.min), max: (r.maxlength || r.maxLength || r.max) };
      const least = range.min ? [{ min: parseInt(range.min), message: `至少输入${range.min}个字符`, trigger: ['blur'] }] : [];
      const limit = range.max ? [{ max: parseInt(range.max), message: `最多输入${range.max}个字符`, trigger: ['blur', 'change'] }] : [];
      const other = (type == 'number' || type == 'editor') ? rule : [...least, ...limit, ...rule];
      const merge = check ? [{ required: true, message: (`${label}不能为空`) }, ...valid, ...other] : [...valid, ...other];
      const rules = r.disabled || this.disabled ? [] : (r.rules ? [...merge, ...r.rules] : merge);
      const attrs = { name: a, prop: a, label, rules, ...r, data: null };
      const after = r.postfix || r.suffix || r.after || r.extra || r.added || r.unit || null;
      const extra = after && (<span class={['form-item-after', a]}>{typeof after !== 'string' ? after() : after}</span>);
      if (this.inline) {
        const style = { padding: `0 ${this.gutter / 2}px` };
        return (
          <el-form-item class={a} style={style} {...{ attrs }}>
            {r.labelSlot && (<template slot="label">{r.labelSlot()}</template>)}
            {this.format(r, a)}
            {extra}
          </el-form-item>
        );
      } else {
        if (r.span) {
          return (
            <el-col key={b} class={a} span={Number(r.span)}>
              <el-form-item class={a} {...{ attrs }}>
                {r.labelSlot && (<template slot="label">{r.labelSlot()}</template>)}
                {this.format(r, a)}
                {extra}
              </el-form-item>
            </el-col>
          );
        } else {
          return (
            <el-col key={b} class={a} style={{ width }}>
              <el-form-item class={a} {...{ attrs }}>
                {r.labelSlot && (<template slot="label">{r.labelSlot()}</template>)}
                {this.format(r, a)}
                {extra}
              </el-form-item>
            </el-col>
          );
        }
      }
    },
    format(a, b) {
      this.option[b] = a;
      const child = a.children || a.child || a.node || null;
      if (child && Object.keys(child).length > 0) {
        return Object.keys(child).map((c, d) => {
          const { ...r } = child[c];
          const space = a.gutter !== undefined ? (a.gutter / 2) : (this.gutter / 4);
          const style = { padding: `0 ${space}px` };
          r.type = r.type ? r.type : a.type;
          const after = r.postfix || r.suffix || r.after || r.extra || r.added || r.unit || null;
          const extra = after && (<span class={['form-item-after', c]}>{typeof after !== 'string' ? after() : after}</span>);
          if (r.span) {
            return (
              <el-col key={d} class={[b, c]} style={style} span={Number(r.span)}>
                {r.labelSlot && (<template slot="label">{r.labelSlot()}</template>)}
                {this.format(r, c)}
                {extra}
              </el-col>
            );
          } else {
            const width = r.width ? r.width : (`${(100 / Object.keys(child).length)}%`);
            return (
              <el-col key={d} class={[b, c]} style={{ width, ...style }}>
                {r.labelSlot && (<template slot="label">{r.labelSlot()}</template>)}
                {this.format(r, c)}
                {extra}
              </el-col>
            );
          }
        });
      } else {
        const attrs = { form: this.form, field: b, ...a };
        return (<AformItem class={b} on-input={this.input} on-change={this.change} {...{ attrs }} />);
      }
    },
    filter() {
      const data = {};
      Object.keys(this.form).length > 0 && (Object.keys(this.form).forEach(a => {
        if (this.option[a]) {
          const { type = '', ...r } = this.option[a];
          const ignore = r.ignore || r.empty || r.blank || r.omit;
          if (!ignore) {
            if (this.form[a]) {
              if (Array.isArray(this.form[a])) {
                if (r.split && r.split.length > 1) {
                  r.split.forEach((b, c) => data[b] = this.form[a][c]);
                } else {
                  const index = type.toLowerCase().trim();
                  if ((index.includes('year') || index.includes('month') || index.includes('date'))) {
                    const { includes = true } = r;
                    if (includes && this.form[a][0] && (this.form[a][1] && this.form[a][1].includes(' 00:00:00'))) {
                      if (moment) {
                        data[a] = [this.form[a][0], moment(this.form[a][1]).subtract(-1, 'days').format('yyyy-MM-DD HH:mm:ss')].toString();
                      } else {
                        data[a] = [this.form[a][0], this.form[a][1].replace(' 00:00:00', ' 23:59:59')].toString();
                      }
                    } else data[a] = this.form[a].toString();
                  } else data[a] = this.form[a].toString();
                }
              } else {
                let value = this.form[a];
                const like = r.like || r.fuzzy || r.vague || r.similar || r.likeness || null;
                if (like) {
                  if (typeof like === 'string') {
                    const mark = like.toUpperCase().trim();
                    if (mark.startsWith('L')) value = `%${value}`;
                    if (mark.startsWith('R')) value = `${value}%`;
                  } else value = `%${value}%`;
                }
                const keywords = r.keywords || r.keyword || r.fields || r.names || r.keys || null;
                if (keywords) {
                  const field = (`${(Array.isArray(keywords) ? keywords.join(',') : keywords)}`).trim();
                  data['keywords'] = (`${field}=${value}`);
                } else data[a] = value.toString();
              }
            }
          }
        }
      }));
      const value = {};
      Object.keys(data).length > 0 && (Object.keys(data).forEach(a => (data[a] && (data[a] != '%' && data[a] != '%%')) && (value[a] = data[a])));
      this.data = value;
      return value;
    },
    submit() {
      if (this.global) {
        const { pageParams } = this.$store.state;
        this.$store.commit('setFormParams', this.filter());
        this.$store.commit('setPageParams', { ...pageParams, page: 1 });
      }
      this.$refs.form.validate((valid, items) => {
        if (valid) {
          this.$emit('submit', this.filter(), this.form, this.option);
        } else if (this.prompt) {
          Object.keys(items).forEach(a => items[a].forEach((b, c) => {
            if (this.timeout) {
              clearTimeout(this.timeout);
              this.timeout = null;
            } else this.timeout = setTimeout(() => {
              this.$message.info(b.message);
              clearTimeout(this.timeout);
              this.timeout = null;
            }, c);
          }));
        }
      });
    },
    cancel() {
      this.$refs.form && this.$refs.form.resetFields && this.$refs.form.resetFields();
      this.$nextTick(() => {
        this.relate(this.config);
        this.$nextTick(() => {
          if (this.global) {
            const { pageParams } = this.$store.state;
            this.$store.commit('setFormParams', this.filter());
            this.$store.commit('setPageParams', { ...pageParams, page: 1 });
          }
          this.$nextTick(() => this.$emit('cancel', this.filter(), this.form, this.option));
        });
      });
    },
    revoke() {
      this.height = 'auto';
      this.$nextTick(() => {
        if (this.timeout) {
          clearTimeout(this.timeout);
          this.timeout = null;
        }
      });
    },
  },
  render() {
    const {
      margin = '0',
      padding = '0',
      size = 'small',
      loading = false,
      submitText = '搜索',
      cancelText = '重置',
      action = [],
      ...rest
    } = this.$attrs;
    const { submit = null, cancel = null } = this.$listeners;
    const style = this.inline ? { margin: `0 -${this.gutter / 2}px` } : {};
    const attrs = { size, rules: this.rules, inline: this.inline, 'label-width': 'auto', 'label-position': 'top', ...rest };
    const config = {};
    Object.keys(this.config).forEach(a => this.config[a] && (config[a] = this.config[a]));
    return (
      <div class={['a-f-search', (this.inline ? 'inline' : null)]} style={{ margin, padding }}>
        <el-form ref="form" id={this.id} disabled={this.disabled} style={style} props={{ model: this.form }} {...{ attrs }}>
          {this.inline ? Object.keys(config).map((a, b) => this.create(a, b)) : (
            <div class="a-f-search-column">
              <el-row gutter={Number(this.gutter)} class="a-f-search-rows a-f-search-main-rows" id={`${this.id}-main-rows`}>
                {Object.keys(config).map((a, b) => (b < this.cols) && this.create(a, b))}
              </el-row>
              {Object.keys(config).length > this.cols && (
                <el-row gutter={Number(this.gutter)} class="a-f-search-rows a-f-search-fold-rows" style={{ height: this.opened ? `${this.height}px` : '0' }}>
                  {Object.keys(config).map((a, b) => (b > (this.cols - 1)) && this.create(a, b))}
                </el-row>
              )}
            </div>
          )}
          {((submit || cancel) || (action.length > 0)) && (
            <div class={['a-f-search-action', ((this.inline && ((Object.keys(config).length) % this.cols) == 0) ? 'anonymous' : null)]}>
              <el-form-item name="action" label="action" label-width="0" style={{ paddingLeft: `${this.inline ? (this.gutter / 2) : this.gutter}px` }}>
                {(!this.inline) && (Object.keys(config).length > this.cols) && (
                  <el-button disabled={loading} type="text" class="collapse-button" on-click={() => this.toggle()}>
                    <i class={`el-icon-arrow-${this.opened ? 'up' : 'down'}`} />
                    <span class={['collapse-text', (this.opened ? 'opened' : null)]}>{this.opened ? '收起' : '展开'}</span>
                  </el-button>
                )}
                {submit && <el-button disabled={loading} type="primary" on-click={this.submit}>{submitText}</el-button>}
                {cancel && <el-button disabled={loading} type="default" on-click={this.cancel}>{cancelText}</el-button>}
                {action.map((a, b) => {
                  const label = a.label || a.title || a.text || a.name || null;
                  if (label) {
                    return (<el-button key={b} disabled={loading} on-click={e => a.click(this.filter(), this.form, this.option, e)} {...{ attrs: a }}>{label}</el-button>);
                  }
                })}
                {this.$slots.action}
              </el-form-item>
            </div>
          )}
        </el-form>
      </div>
    );
  }
}